import { TriangleAlert } from "lucide-react";
import Modal from "./Modal";

export default function ConfirmDialog({
  title,
  message,
  confirmLabel = "حذف",
  busy = false,
  error = "",
  onConfirm,
  onClose,
}) {
  return (
    <Modal
      title={title}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn btn-danger" onClick={onConfirm} disabled={busy}>
            {busy ? "در حال انجام…" : confirmLabel}
          </button>
          <button type="button" className="btn btn-ghost" onClick={onClose} disabled={busy}>
            انصراف
          </button>
        </>
      }
    >
      {error && <div className="alert alert-error">{error}</div>}
      <div className="confirm-body">
        <span className="confirm-icon" aria-hidden="true">
          <TriangleAlert size={22} strokeWidth={1.9} />
        </span>
        <p>{message}</p>
      </div>
    </Modal>
  );
}
